import React from 'react'
import type { Icon } from 'shared/utils'

const Biking = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'biking',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 33 32"
            {...otherProps}>
            <path
                d="M29.408 14.344a6.452 6.452 0 011.912 2.28l-.06.136c.786 2.118.274 2.112-.803 2.099-.088-.001-.181-.003-.277-.003h-7.768c-.761 0-1.277.39-1.785.774-.526.398-1.044.788-1.817.735l-5.882.075H3.58a4.011 4.011 0 01-1.034-.105 1.526 1.526 0 01-1.033-.77 2.5 2.5 0 01-.107-1.764 8.521 8.521 0 012.31-3.952 6.45 6.45 0 013.375-1.629c-.547-.527-.045-1.915.973-1.915a51.787 51.787 0 017.843.498 1.018 1.018 0 01.601.641 1.003 1.003 0 01-.13.867 3.162 3.162 0 00-.79 4.117 3.215 3.215 0 003.162.86 9.098 9.098 0 014.15-3.62c-.038-.196-.103-.44-.18-.73a21.37 21.37 0 01-.368-1.562c-.32-1.674-.912-2.61-1.733-2.82a1.531 1.531 0 00-.881 0c-.16.037-.327.037-.487 0-.851-.197-.957-1.614 0-2.067a4.502 4.502 0 012.387-.18c.159.034.309.1.44.195l.517.423c.228-1.237 1.155-2.067 1.748-2.067h.32c.288.076.44.227.44.664.292 1.158.52 2.331.684 3.514 0 .226-.82.256-1.429.09H24.1a45.318 45.318 0 002.356 4.027h.213c.994.18 1.932.587 2.74 1.189zM22.58 20.65a1.524 1.524 0 00-.547.302 3.833 3.833 0 00.243 2.549c2.204 3.951 7.296.89 7.722-3.017-1.764 0-5.488 0-7.418.121v.045zM4.34 22.25c-.258 3.409 3.04 6.138 6.506 2.91.241-.234.464-.486.668-.753a7.684 7.684 0 001.08-2.067H7.882l-3.542-.09z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Biking }
